import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./MainBlog.scss";
import { useNavigate } from "react-router-dom";
import { blogItems, formatBlogDate } from "./blogData";

const PreviousArrow = ({ onClick }: { onClick?: () => void }) => (
  <button
    type="button"
    className="blog__arrow blog__arrow--previous"
    onClick={onClick}
    aria-label="Itens anteriores do blog"
  >
    ‹
  </button>
);

const NextArrow = ({ onClick }: { onClick?: () => void }) => (
  <button
    type="button"
    className="blog__arrow blog__arrow--next"
    onClick={onClick}
    aria-label="Próximos itens do blog"
  >
    ›
  </button>
);

const MainBlog = () => {
  const navigate = useNavigate();

  const openBlogPost = (id: string) => {
    navigate(`/blog/${id}`);
  };

  const settings = {
    dots: true,
    infinite: blogItems.length > 4,
    speed: 600,
    slidesToShow: Math.min(4, blogItems.length),
    slidesToScroll: 1,
    arrows: blogItems.length > 1,
    prevArrow: <PreviousArrow />,
    nextArrow: <NextArrow />,
    autoplay: blogItems.length > 1,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: { slidesToShow: Math.min(3, blogItems.length) },
      },
      {
        breakpoint: 1100,
        settings: { slidesToShow: Math.min(2, blogItems.length), arrows: false },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, arrows: false },
      },
    ],
  };

  return (
    <section className="blog" id="blog">
      <div className="blog__container" data-aos="fade-up">
        <h2>Insights sobre saúde corporativa, produtividade e bem-estar no trabalho</h2>
        <p className="blog__intro">
          Conheça as práticas e soluções que podem fazer parte de um programa de
          bem-estar corporativo personalizado.
        </p>

        <div className="blog__carousel-shell">
          <div className="blog__carousel">
            <Slider {...settings}>
              {blogItems.map((item) => (
                <article key={item.id} className="blog__slide" id={item.sectionLink}>
                  <div className="blog__card">
                    <div className="blog__image">
                      <img src={item.imageUrl} alt={item.title} />
                    </div>
                    <div className="blog__card-content">
                      <h3>{item.title}</h3>
                      <div className="blog__meta">
                        <span>Por {item.author}</span>
                        <span aria-hidden="true">•</span>
                        <time dateTime={item.createdAt}>{formatBlogDate(item.createdAt)}</time>
                        <span aria-hidden="true">•</span>
                        <span>{item.readingTime} min</span>
                      </div>
                      <p>{item.description}</p>
                      <button
                        type="button"
                        className="main-blogs__button"
                        onClick={() => openBlogPost(item.id)}
                      >
                        Ler mais
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </Slider>
          </div>
        </div>

        <button
          type="button"
          className="main-blogs__all-button"
          onClick={() => navigate("/blog")}
        >
          Ver todos os conteúdos
        </button>
      </div>
    </section>
  );
};

export default MainBlog;
